import React, { useEffect, useState } from "react";
import { Select, SelectOnChangeData } from "@fluentui/react-components";

interface IYearDropdown {
    projectChangeParentHandler: any;
}
export const YearDropdown = ({ projectChangeParentHandler }: IYearDropdown) => {
    const [years, setYears] = useState<number[]>();
    const [year, setYear] = useState<number | null>();

    useEffect(() => {
        const _range = 20;
        const _year = new Date().getFullYear();
        const _years = Array.from(
            new Array(20),
            (_val, index) => index + _year - _range / 2
        );
        setYear(_year);
        setYears(_years);
    }, []);

    useEffect(() => {
        projectChangeParentHandler(year);
    }, [year]);

    const handleOnChange = (_e: any, data: SelectOnChangeData) => {
        setYear(data.value as number);
    };

    return (
        <>
            <Select
                value={year?.toString() || ""}
                onChange={handleOnChange}
                placeholder="Select year"
            >
                {years?.map((yearOption) => (
                    <option key={yearOption} value={yearOption}>
                        {yearOption}
                    </option>
                ))}
            </Select>
        </>
    );
};
